<template>
    <div>
        <v-overlay :value="loadingUploadCsv">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <upload-csv />
        <csv-list />
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CsvList from "@/views/upload-csv/cards/csv-list";
import UploadCsv from "@/views/upload-csv/cards/upload-csv";

export default {
    name: "upload-csv-view",
    components: { UploadCsv, CsvList },
    computed: {
        ...mapState(["loadingUploadCsv"])
    },
    mounted() {
        this.getPaymentImports();
        let uri = window.location.search.substring(1);
        if (new URLSearchParams(uri).get("error")) {
            this.setRequestError(true);
            this.setErrorMessage("Failed");
        }
    },
    methods: {
        ...mapMutations(["setRequestError", "setErrorMessage"]),
        ...mapActions(["getPaymentImports"])
    }
};
</script>

<style scoped>
.has-error {
    color: red;
    font-size: small;
    margin: 10px 10px 0px;
}
</style>
